import { render, staticRenderFns } from "./FormularioWindow.vue?vue&type=template&id=055e0891"
import script from "./FormularioWindow.vue?vue&type=script&lang=js"
export * from "./FormularioWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports